import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import ErrorPage from '../pages/_error';
import { PageError } from '../store/app/types';
import { RootState } from '../store/root-reducer';
import { APP_NAME } from '../types/app';

const AppWrapper: React.FC<{ error?: PageError; appName: APP_NAME; children: ReactElement }> = ({
  error,
  children,
  appName,
}) => {
  return error ? (
    <ErrorPage err={error} statusCode={error.code} title={error.message} skipErrorLog={true} {...{ appName }} />
  ) : (
    children
  );
};

const mapStateToProps = (state: RootState) => ({
  error: state.app.error,
  appName: state.app.appName,
});

export default connect(mapStateToProps)(AppWrapper);
